// extracted by mini-css-extract-plugin
export default {"container":"TimeoutModal__container___S2eEh","header":"TimeoutModal__header___NYWJV","icon":"TimeoutModal__icon___w6m2o","buttonsWrapper":"TimeoutModal__buttonsWrapper___Asmmg"};